import React from "react";
import {LookDataType} from "./LookTypes";
import TitleBlock from "./TitleBlock";
import TagsBlock from "./TagsBlock";

const MobileTitleBlock: React.FC<{look: LookDataType}> = ({look}) => {
  return (
    <>
      <div className="mobile-title-block">
        <TitleBlock look={look} isMobile={true} />
      </div>
      <TagsBlock look={look} isMobile={true} />
    </>
  );
};

export default MobileTitleBlock;
